import * as types from '../types.js';

export default {

	html: `
		<style>
			#lot #company_id		{ width: 10rem;		}
			#lot #id				{ width: 5rem; text-align: right;	}
			#lot #input_id			{ width: 5rem; text-align: right;	}
			#lot #product_id		{ width: 20rem;		}
			#lot #lot_number		{ width: 10rem;		}
			#lot #serial			{ width: 10rem;		}
			#lot #manufacture_date	{ width: 7rem;		}
			#lot #expiration_date	{ width: 7rem;		}
			#lot #quantity			{ width: 5rem; text-align: right;	}
			#lot #status			{ width: 10rem;		}
		</style>
		<form id="lot" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="products">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do lote">Lote
					<input id="id" type="text" disabled>
				</label>
				<label title="Número da entrada">Entrada<sup>*</sup>
					<input id="input_id" type="text" required>
				</label>
				<label title="Produto">Produto<sup>*</sup>
					<input id="product_id" type="text" list="products" required>
				</label>
			</div>
			<div>
				<label title="Numeração do lote">Numeração<sup>*</sup>
					<input id="lot_number" type="text" required>
				</label>
				<label title="Serial opcional (letras e números, até 20)">Serial
					<input id="serial" type="text" maxlength="20" pattern="[A-Za-z0-9]*" autocomplete="off">
				</label>
				<label title="Data de fabricação">Fabricação<sup>*</sup>
					<input id="manufacture_date" type="text" required>
				</label>
				<label title="Data de validade">Validade<sup>*</sup>
					<input id="expiration_date" type="text" required>
				</label>
				<label title="Quantidade">Qtde<sup>*</sup>
					<input id="quantity" type="text" required>
				</label>
				<label title="Status do lote">Status<sup>*</sup>
					<input id="status" type="text" list="lot_status" value="10" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#lot',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#input_id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#product_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('products', { labels: ['sku', 'name'] })] },
		{ properties: { selector: '#lot_number' }, types: [] },
		{ properties: { selector: '#serial' }, types: [types.caps()] },
		{ properties: { selector: '#manufacture_date' }, types: [types.date()] },
		{ properties: { selector: '#expiration_date' }, types: [types.date()] },
		{ properties: { selector: '#quantity' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#status' }, types: [types.opt_lot_status(), types.datalist()] },
	]

};

